import React from "react";
import { Form, Input, Button } from "antd";
import { useNavigate, Link } from "react-router-dom";
import { postApiWithoutRedirect } from "../services/api";
import { LockOutlined, MailOutlined, UserOutlined } from "@ant-design/icons";

const FormItem = Form.Item;

const Register = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      const { firstName, lastName, email, password } = values;
      const payload = {
        email,
        username: email,
        name: `${firstName} ${lastName}`,
        password
      };
      await postApiWithoutRedirect("/user/register", payload);
      navigate("/login");
    } catch (error) {
      console.error("Registration failed:", error);
    }
  };

  return (
    <Form
      form={form}
      name="register"
      onFinish={onFinish}
      autoComplete="off"
      style={{ gap: '4px' }}
    >
      <div style={{ marginBottom: "4px" }}>
        <label style={{ 
          color: "#08184F", 
          fontSize: "14px", 
          fontWeight: "500" 
        }}>
          First Name
        </label>
      </div>
      <FormItem
        name="firstName"
        validateTrigger="onBlur"
        rules={[{ required: true, message: "Please input your first name!" }]}
        style={{ marginBottom: "8px" }}
      >
        <Input prefix={<UserOutlined />} placeholder="First Name" />
      </FormItem>

      <div style={{ marginBottom: "4px" }}>
        <label style={{ 
          color: "#08184F", 
          fontSize: "14px", 
          fontWeight: "500" 
        }}>
          Last Name
        </label>
      </div>
      <FormItem
        name="lastName"
        validateTrigger="onBlur"
        rules={[{ required: true, message: "Please input your last name!" }]}
        style={{ marginBottom: "8px" }}
      >
        <Input prefix={<UserOutlined />} placeholder="Last Name" />
      </FormItem>

      <div style={{ marginBottom: "4px" }}>
        <label style={{ 
          color: "#08184F", 
          fontSize: "14px", 
          fontWeight: "500" 
        }}>
          Email Address
        </label>
      </div>
      <FormItem
        name="email"
        validateTrigger="onBlur"
        rules={[
          { required: true, message: "Please input your email!" },
          { type: "email", message: "Please enter a valid email!" },
        ]}
        style={{ marginBottom: "8px" }}
      >
        <Input prefix={<MailOutlined />} placeholder="Email" />
      </FormItem>

      <div style={{ marginBottom: "4px" }}>
        <label style={{ 
          color: "#08184F", 
          fontSize: "14px", 
          fontWeight: "500" 
        }}>
          Password
        </label>
      </div>
      <FormItem
        name="password"
        validateTrigger="onBlur"
        rules={[
          { required: true, message: "Please input your password!" },
          {
            pattern:
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[.,#@$!%*?&])[A-Za-z\d.,#@$!%*?&]{8,}$/i,
            message:
              "Password should contain at least 8 character with at least one of these symbols [.,#@$!%*?&], one uppercase, one lower case letter and a number",
          },
        ]}
        style={{ marginBottom: "8px" }}
      >
        <Input.Password prefix={<LockOutlined />} placeholder="Password" />
      </FormItem>

      <FormItem>
        <Button
          style={{ 
            backgroundColor: "#0050b5",
            color: "#fff",
            width: "78px",
            height: "40px",
            borderRadius: "6px",
            border: "none",
            marginTop: "16px"
          }}
          htmlType="submit"
          shape="default"
        >
          Register
        </Button>
      </FormItem>
    </Form>
  );
};

export default Register; 